import React from "react";
import { RealCar } from "./cars/RealCar";
import { Award, Flag, Workflow } from "lucide-react";

export const HeroBanner = ({ view = "hero", go = () => {} }) => {
  const Btn = ({ id, icon: Icon, label, activeColor = "bg-hitch hover:bg-blue-950" }) => {
    const isActive = view === id;
    return (
      <button
        onClick={() => go(id)}
        className={`px-5 py-3 flex items-center gap-2 rounded-lg font-semibold shadow transition ${
          activeColor
        }`}
      >
        <Icon className="w-5 h-5" />
        {label}
      </button>
    );
  };

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden bg-gradient-to-b from-gray-900 to-black py-16 md:py-24 border-b border-white/10"
    >
      <style>{`
        @keyframes flag {0%{background-position:0 0}100%{background-position:200px 0}}
        @keyframes streak {0%{transform:translateX(-20%) skewX(-15deg); opacity:0} 20%{opacity:.9} 100%{transform:translateX(120%) skewX(-15deg); opacity:0}}
      `}</style>

      {/* Bandera a cuadros */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(90deg, rgba(255,255,255,.08) 50%, transparent 50%), linear-gradient(0deg, rgba(255,255,255,.08) 50%, transparent 50%)",
          backgroundSize: "24px 24px, 24px 24px",
          animation: "flag 18s linear infinite",
        }}
      />
      {/* Glow rojo */}
      <div className="absolute -inset-x-40 top-1/2 h-[400px] -translate-y-1/2 bg-hitch/10 blur-3xl" />

      <div className="max-w-6xl mx-auto px-6 relative z-10 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            <span className="text-white">SOLUTION</span>{" "}
            <span className="text-hitch">DAY</span>
          </h1>

          <p className="mt-1 mb-1 text-white/70 max-w-xl">Un día a toda velocidad</p>
          <p className="text-xs tracking-[0.35em] text-white/60 mb-2">POR VISUALK & HITCH</p>

          <div className="mt-6 flex flex-wrap gap-3">
            <Btn id="podium" icon={Award} label="Podio" activeColor="bg-hitch hover:bg-blue-950" />
            <Btn id="diagram" icon={Workflow} label="Flujo de trabajo" />
            <Btn id="standings" icon={Flag} label="Posiciones" activeColor="bg-hitch hover:bg-blue-950" />
          </div>

          <div className="mt-6 flex items-center gap-3 opacity-90 bg-white p-3 justify-center">
            <p className="text-black">Partners:</p>
            <img src="/partners/sap_b1.webp" className="h-6 object-contain" alt="SAP" />
            <img src="/partners/visualk-slogan.png" className="h-10 object-contain" alt="VisualK" />
          </div>
        </div>

        {/* Carro animado */}
        <div className="relative h-[260px] md:h-[320px] hidden md:block">
          <div className="absolute inset-y-1/4 left-0 right-0 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-60 animate-[streak_2s_ease-in-out_infinite]" />
          <RealCar
            sources={["/cars/ferrari.gif"]}
            direction="ltr"
            startY="50%"
            width={520}
            duration={6}
            delay={0.1}
          />
        </div>
      </div>
    </section>
  );
};
